module.exports = __webpack_public_path__ + "static/media/Saeid Asgari Taghanaki.cb603747.png";